module.exports = __webpack_public_path__ + "static/media/DT-LOGO-2023-Color.4011f99e.png";